<div
  class="celo-cursor-pointer icon_size"
  [ngClass]="{ 'celo-cursor-pointer': clickable }"
  [style.height.px]="size ? size : 'auto'"
  [style.width.px]="size ? size : 'auto'"
  (click)="clickable ? openBadgeInfo() : ''"
>
  @if (!isExternal) {
    @if (identityVerificationStatus === "Verified") {
      <div class="fh fw">
        @if (
          (!profession ||
            profession.verificationStatus !== "Verified" ||
            doNotShowProfessionVerificationStatus) &&
          !isProfessionVerified
        ) {
          <img
            class="verified-star"
            [matTooltip]="showTooltip ? 'Identity verified' : ''"
            src="../../../assets/icons/ic-verified.svg"
          />
        }
        @if (
          (profession &&
            profession.verificationStatus === "Verified" &&
            !doNotShowProfessionVerificationStatus) ||
          isProfessionVerified
        ) {
          <img
            class="verified-star"
            [matTooltip]="showTooltip ? 'Verified profession' : ''"
            src="../../../assets/icons/ic-verified-red.svg"
          />
        }
      </div>
    }
    @if (identityVerificationStatus !== "Verified") {
      <div class="fh fw">
        @if (!isWorkspaceVerified && !hideUnverifiedBadge) {
          <div class="fh fw">
            <img
              class="verified-circle"
              [matTooltip]="showTooltip ? 'Unverified user' : ''"
              src="../../../assets/icons/ic-unverified.svg"
            />
          </div>
        }
        @if (isWorkspaceVerified) {
          <div class="fh fw">
            <img
              class="verified-circle"
              [matTooltip]="showTooltip ? 'Verified workspace' : ''"
              src="../../../assets/icons/ic-verified-workspace.svg"
            />
          </div>
        }
      </div>
    }
  } @else {
    <div class="fh fw">
      <img
        [matTooltip]="showTooltip ? 'External user' : ''"
        src="../../../assets/icons/ic-external.svg"
      />
    </div>
  }
</div>
